import axios from "axios";
import {MUTATION_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_STCK_MUTATION_LIST = 'FETCH_STCK_MUTATION_LIST'
export const RECEIVE_STCK_MUTATION_LIST = 'RECEIVE_STCK_MUTATION_LIST'
export const FAILED_STCK_MUTATION_LIST = 'FAILED_STCK_MUTATION_LIST'

export function fetchStckMutations(_id_master_item){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_STCK_MUTATION_LIST});
        axios({
            method: 'post',
            url: MUTATION_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_master_item : _id_master_item
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_MUTATION_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_MUTATION_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_MUTATION_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_MUTATION_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_MUTATION_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_MUTATION_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_MUTATION_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}